(function () {
  'use strict';

  angular
    .module('app')
    .service('BookingItemServiceItemModalService', BookingItemServiceItemModalService);

  BookingItemServiceItemModalService.$inject = ['ModalService'];

  function BookingItemServiceItemModalService(ModalService) {
    var preventModalClose = {
      backdrop: 'static',
      keyboard: false,
    };

    var service = {
      openBookingItemServiceItemStandardCostBased: openBookingItemServiceItemStandardCostBased,
    };

    return service;

    ////////////////////////

    // --------------------------- openBookingItemServiceItemStandardCostBased -------------------------

    function openBookingItemServiceItemStandardCostBased(
      bookingItemServiceItem,
      bookingItem,
      booking,
      documentDateExchangeRate,
      successCallback
    ) {
      // , taxes
      ModalService.showModal({
        templateUrl:
          './app/ajs/bookings/booking-items/booking-item-service-items/' +
          'modals/booking-item-service-item-standard-cost-based-modal.html',
        controller: BookingItemServiceItemStandardCostBasedCtrl,
        controllerAs: 'vm',
        inputs: {
          bookingItemServiceItem: bookingItemServiceItem,
          bookingItem: bookingItem,
          booking: booking,
          // taxes:              taxes,
          documentDateExchangeRate: documentDateExchangeRate,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        modal.element.modal(preventModalClose);
      });
    }

    function BookingItemServiceItemStandardCostBasedCtrl(
      $element,
      bookingItemServiceItem,
      bookingItem,
      booking,
      documentDateExchangeRate,
      successCallback
    ) {
      var vm = this;

      vm.bookingItemServiceItem = bookingItemServiceItem;
      vm.bookingItem = bookingItem;
      vm.booking = booking;
      // vm.taxes = taxes;
      vm.documentDateExchangeRate = documentDateExchangeRate;

      // Methods
      vm.onBookingItemServiceItemStandardCostBasedSaved =
        onBookingItemServiceItemStandardCostBasedSaved;

      function onBookingItemServiceItemStandardCostBasedSaved(bookingItemServiceItemObj) {
        $element.modal('hide');
        successCallback(bookingItemServiceItemObj);
      }
    }
  }
})();
